import { useSubscription } from "../context/SubscriptionContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";

export default function TrialBanner() {
  const { sub, status } = useSubscription();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (status !== "trialing" || !sub?.trial_seconds_remaining) return null;

  const totalSec = sub.trial_seconds_remaining;
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/30 px-6 py-2.5 flex items-center justify-center gap-4 sticky top-0 z-40" data-testid="trial-banner">
      <Clock className="w-3.5 h-3.5 text-amber-500" />
      <span className="font-mono-data text-xs tracking-widest uppercase text-amber-500">
        {t("trial.banner", { days, hours })}
      </span>
      <button
        onClick={() => navigate("/pricing")}
        data-testid="trial-upgrade-btn"
        className="font-mono-data text-xs uppercase tracking-widest text-white underline underline-offset-4 hover:text-amber-500"
      >
        {t("trial.upgrade")} →
      </button>
    </div>
  );
}
